import { COLUMN_ACCESS_GROUP, COLUMN_AREA, COLUMN_BUILDING, COLUMN_DISPLAY_NAME, COLUMN_DOOR, COLUMN_FLOOR, COLUMN_SITE } from "../../constants/column-types";
import {FILTER_ACCESS_GROUP, FILTER_AREA, FILTER_BUILDINGS, FILTER_DOORS, FILTER_FLOORS, FILTER_SITES, FILTER_TAGHOLDERS} from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const PersonAccessReportColumns: TableColumn[] = [
    {
        heading: "Display Name",
        accessor: "displayName",
        isNumeric: false,
        id: 0,
        active: false,
        translationKey: "displayName",
        columnId: COLUMN_DISPLAY_NAME,
        searchOnName: "masterId",
        lookupName: "masterId",
        filterId: FILTER_TAGHOLDERS,
        settingDataName: 'master',
        isFilterOnlyColumn: true
    },
    {
        heading: "Door",
        accessor: "door",
        isNumeric: false,
        id: 1,
        active: true,
        sortByName: "locationName",
        sortDirection: "asc",
        translationKey: "door",
        columnId: COLUMN_DOOR,
        searchOnName: "locationId",
        lookupName: "locationId",
        filterId: FILTER_DOORS,
        settingDataName: 'location'
    },
    {
        heading: "Access Group",
        accessor: "accessGroup",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "accessGroup",
        columnId: COLUMN_ACCESS_GROUP,
        sortDirection: "asc",
        sortByName: "accessGroupName",
        settingDataName: 'accessGroup',
        filterId: FILTER_ACCESS_GROUP,
        searchOnName: "accessGroupId",
        lookupName: "accessGroupId"
    },
    {
        heading: "Access Area",
        accessor: "area",
        isNumeric: false,
        id: 3,
        active: true,
        sortByName: "areaName",
        sortDirection: "asc",
        translationKey: "accessArea",
        columnId: COLUMN_AREA,
        searchOnName: "areaId",
        lookupName: "areaId",
        filterId: FILTER_AREA,
        settingDataName: 'area'
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 4,
        active: true,
        sortByName: "siteName",
        sortDirection: "asc",
        translationKey: "site",
        columnId: COLUMN_SITE,
        searchOnName: "siteId",
        lookupName: "site",
        filterId: FILTER_SITES,
        settingDataName: 'site'
    },
    {
        heading: "Building",
        accessor: "building",
        isNumeric: false,
        id: 5,
        active: false,
        sortByName: "buildingName",
        sortDirection: "asc",
        translationKey: "building",
        columnId: COLUMN_BUILDING,
        searchOnName: "buildingId",
        lookupName: "buildingId",
        filterId: FILTER_BUILDINGS,
        settingDataName: 'building'
    },
    {
        heading: "Floor",
        accessor: "floor",
        isNumeric: false,
        id: 6,
        active: false,
        sortByName: "floorName",
        sortDirection: "asc",
        translationKey: "floor",
        columnId: COLUMN_FLOOR,
        filterId: FILTER_FLOORS,
        searchOnName: "floorId",
        lookupName: "floorId"
    },
];

export default PersonAccessReportColumns;
